import { useQuery } from 'react-query';
import { fetchCertificates } from 'src/services/courses';

export const useCertificates = () => {
  return useQuery('certificates', () => fetchCertificates());
};
